import {HandlerList} from "../../../infrastructure/handlers/handler-list";
import {PropositionBetsWidgetFetchHandler} from "./proposition-bets-widget.fetch-handler";
import {TimingHandler} from "../../../infrastructure/handlers/timing-handler";
import {EntityClickEventHandler} from "../../../core/handlers/entity-click-event.handler";
import {PropositionBetsWidgetPopulateDataHandler} from "./proposition-bets-widget.populate-data.handler";
import {PropositionBetsWidgetMarketClickEventHandler} from "./proposition-bets-widget.market.click-event.handler";
import {PropositionBetsWidgetMarketShowMoreClickEventHandler} from "./proposition-bets-widget.market-show-more.click-event.handler";
import {PropositionBetsPopupDisplayHandler} from "../../../core/handlers/proposition-bets.popup-display.handler";

export class PropositionBetsWidgetHandlers extends HandlerList {
  static injectables = [
    PropositionBetsWidgetFetchHandler,
    PropositionBetsPopupDisplayHandler,
    EntityClickEventHandler,
    PropositionBetsWidgetPopulateDataHandler,
    PropositionBetsWidgetMarketClickEventHandler,
    PropositionBetsWidgetMarketShowMoreClickEventHandler,
    TimingHandler
  ];

  constructor(
    propositionBetsWidgetFetchHandler: PropositionBetsWidgetFetchHandler,
    propositionBetsPopupDisplayHandler: PropositionBetsPopupDisplayHandler,
    entityClickEventHandler: EntityClickEventHandler,
    propositionBetsWidgetPopulateDataHandler: PropositionBetsWidgetPopulateDataHandler,
    propositionBetsWidgetMarketClickEventHandler: PropositionBetsWidgetMarketClickEventHandler,
    propositionBetsWidgetMarketShowMoreClickEventHandler: PropositionBetsWidgetMarketShowMoreClickEventHandler,
    timingHandler: TimingHandler,
  ) {
    super();

    [
      propositionBetsWidgetFetchHandler,
      propositionBetsPopupDisplayHandler,
      entityClickEventHandler,
      propositionBetsWidgetPopulateDataHandler,
      propositionBetsWidgetMarketClickEventHandler,
      propositionBetsWidgetMarketShowMoreClickEventHandler,
      timingHandler
    ].forEach(handler => this.add(handler));
  }
}
